import React from "react";

export const LoadingFallback: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <div className="text-lg">Loading...</div>
        <div className="text-sm text-muted-foreground">Please wait</div>
      </div>
    </div>
  );
};
